import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"][appInteger]',
  standalone: false
})
export class InputIntegerDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  keyDown($event: KeyboardEvent) {
    const intRx = /\d/;
    if ($event.metaKey || $event.ctrlKey || $event.key?.length > 1 || intRx.test($event.key)) {
      return;
    }
    // invalid character, prevent input
    $event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  paste($event: ClipboardEvent) {
    const intRx = /^\d+$/;
    const text = $event.clipboardData?.getData('text')?.trim();
    if (text && !intRx.test(text)) {
      $event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput($event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    const newValue = input.value.replace(/\D+/g, '');
    if (input.value !== newValue) {
      input.value = newValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}
